import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { CatBusinessLineModel } from 'src/app/model/cat-business-line.model';
import { CatBusinessLineService } from 'src/app/services/cat-business-line.service';

@Component({
  selector: 'app-modal-business-line',
  templateUrl: './modal-business-line.component.html',
  styleUrls: ['./modal-business-line.component.css']
})
export class ModalBusinessLineComponent implements OnInit {
  @Input() businessLine: CatBusinessLineModel;
  @Input() mode: string;

  // estado pagina
  public viewStatus = 1;

  // mascaras
  public customPatterns = {
    'A': { pattern: new RegExp('[a-zA-Z0-9ñÑ ]') },                     // inputs regulares
    'C': { pattern: new RegExp('[a-zA-Z0-9áéíóúÁÉÍÓÚüÜñÑ,._:%\/() \-]') },       // comentarios (acepta acentos, comas y puntos)
    'N': { pattern: new RegExp('[0-9]') }
  };

  ////////////////
  constructor(
    private businessLineService: CatBusinessLineService,
    private modalService: NgbModal,
    private toastr: ToastrService
  ) { }
  ngOnInit() { }

  //
  toggleActive = () => this.businessLine.iActiveId = this.businessLine.iActiveId ? 0 : 1;
  isValid = () => {
    let valid = true;
    let errors = [];
    if (this.descriptionError()) errors.push('Necesita capturar una descripción.');
    if (errors.length > 0) {
      valid = false;
      this.toastr.error(errors.join('<br>'), '¡Atención!', { enableHtml: true });
    }
    return valid;
  }
  save = () => {
    if (this.isValid()) {
      // mostrar spinner
      this.viewStatus = 0;
      // enviar informacion
      this.businessLine.vDescription = this.businessLine.vDescription.toUpperCase();
      let userName = localStorage.getItem('com_userName');
      this.businessLineService.save(userName, this.businessLine)
        .pipe(
          tap((resp: any) => {
            console.log(resp);
            if (resp && resp.codeHttpStatus === 200) {
              this.modalService.dismissAll('success');
              this.toastr.success('La línea de negocio se guardó con éxito.');
            } else {
              this.viewStatus = 1;
              this.toastr.error(resp && resp.messageError ? resp.messageError : 'Ocurrió un error al intentar guardar la línea de negocio.');
            }
          }),
          catchError(error => {
            console.log(error);
            this.viewStatus = 1;
            return of(this.toastr.error('Ocurrió un error al intentar guardar la línea de negocio.'));
          })
        )
        .subscribe();
    }
  }
  close = () => this.modalService.dismissAll();

  // HELPERS
  descriptionError = () => !this.businessLine.vDescription || this.businessLine.vDescription.trim() === '';
}
